import React from 'react';
import Hero from '../blocks/home/Hero';
import Quote from '../blocks/home/Quote';
import Projects from '../blocks/home/Projects';
import Skills from '../blocks/home/Skills';
import About from '../blocks/home/About';
import Contacts from '../blocks/home/Contacts';

const Home = ({ t, locale }) => {
  // Get the projects and skills data from the full locale
  const projectsData = locale?.projects || {};
  const skillsData = locale?.skills || {};

  return (
    <>
      <Hero t={t.hero} />
      <Quote t={t.quote} />
      <Projects t={t.projects} projectsData={projectsData} />
      <Skills t={t.skills} skillsData={skillsData} />
      <About t={t.about} />
      <Contacts t={t.contacts} />
    </>
  );
};

export default Home;